import {
  take, race,
} from 'redux-saga/effects';
import { CONFIRM_ACTION_REQUESTED, PROCEED_ACTION, CANCEL_ACTION } from './actionTypes';

export default function* watch() {
  try {
    while (true) {
      const confirmAction = yield take(CONFIRM_ACTION_REQUESTED);
      const { proceed, cancel } = yield race({
        proceed: take(PROCEED_ACTION),
        cancel: take(CANCEL_ACTION),
      });


      if (proceed) {
        confirmAction.payload.actionFunc.apply(null, confirmAction.payload.actionFuncArgs);
      }

      if(cancel){
        confirmAction.payload.onCancel.apply(null, confirmAction.payload.onCancelArgs);
      }
    }
  } catch (e) {
    console.log(e);
  }
}



// WEBPACK FOOTER //
// ./src/services/confirmAction/saga.js